export type ThemeMode = 'light' | 'dark' | 'contrast'

export const resolveThemeMode = (
  enableDarkMode: boolean | undefined,
  appMode: string | undefined,
  forcedThemeModeEnrollment: ThemeMode | 'none' | undefined
): ThemeMode => {
  if (!enableDarkMode) {
    return 'light'
  }

  if (forcedThemeModeEnrollment && forcedThemeModeEnrollment !== 'none') {
    return forcedThemeModeEnrollment
  }

  if (appMode === 'dark') {
    return 'dark'
  }

  return 'light'
}
